import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "에디터 통합",
  "description": "Turborepo를 최대한 활용하기"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "turbo로 최상의 경험을 얻으려면 Turborepo는 에디터와 통합하기 위한 몇 가지 유틸리티를 제공합니다."
  }, {
    "heading": "turbojson을-위한-json-schema",
    "content": "Turborepo는 JSON Schema를 사용하여 turbo.json 파일에서 자동 완성을 제공합니다. turbo.json에 $schema 키를 포함하면 에디터가 잘못된 형식이나 누락된 키가 있는 경우 전체 문서 및 린팅을 제공할 수 있습니다."
  }, {
    "heading": "웹에서-가져오기",
    "content": "아래 표시된 URL에서 schema.json에 액세스할 수 있습니다. 이는 에디터 내 검증을 보기 위해 패키지 매니저의 설치 명령을 실행할 필요가 없다는 장점이 있습니다."
  }, {
    "heading": "웹에서-가져오기",
    "content": "https://turborepo.com/schema.<version>.json 형식을 따르는 메이저 버전 schema.json도 사용할 수 있습니다."
  }, {
    "heading": "node_modules에서-가져오기",
    "content": "Turborepo 2.4부터 패키지 매니저의 설치 명령을 실행하면 node_modules에서 schema.json을 사용할 수 있습니다:"
  }, {
    "heading": "node_modules에서-가져오기",
    "content": "리포지토리의 루트에 turbo를 설치하는 것을 권장하므로, 스키마 경로는\n리포지토리 루트의 node_modules를 가리켜야 합니다. 패키지\n구성에서는\n../../node_modules/turbo/schema.json과 같은 경로를 사용해야 할 수 있습니다."
  }, {
    "heading": "환경-변수-린팅",
    "content": "환경 변수를 처리하는 것은 Turborepo에서 애플리케이션을 구축하는 중요한 부분입니다."
  }, {
    "heading": "환경-변수-린팅",
    "content": "eslint-config-turbo 패키지는 ESLint 설정을 확장하여 모든 환경 변수를 처리했는지 확인하는 데 도움을 줍니다."
  }, {
    "heading": "turborepo-lsp",
    "content": "JSON Schema에서 제공하는 것보다 더 많은 자동 완성 및 린팅을 활성화하고, 잘못된 글로브, 존재하지 않는 태스크나 패키지에 대한 참조를 위한 에디터 내 힌트 및 추가 리포지토리 가시성 도구를 제공합니다."
  }, {
    "heading": "turborepo-lsp",
    "content": "설치하려면 VSCode Extension Marketplace를 방문하세요."
  }, {
    "heading": "turborepo-lsp",
    "content": "언어 서버는 Language Server\nProtocol을 지원하는\n모든 에디터에서 사용할 수 있습니다. 관심을 표명하려면 이슈\n트래커에 요청을 기록하세요."
  }],
  "headings": [{
    "id": "turbojson을-위한-json-schema",
    "content": "turbo.json을 위한 JSON Schema"
  }, {
    "id": "웹에서-가져오기",
    "content": "웹에서 가져오기"
  }, {
    "id": "node_modules에서-가져오기",
    "content": "node_modules에서 가져오기"
  }, {
    "id": "환경-변수-린팅",
    "content": "환경 변수 린팅"
  }, {
    "id": "turborepo-lsp",
    "content": "Turborepo LSP"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#turbojson을-위한-json-schema",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo.json"
    }), "을 위한 JSON Schema"]
  })
}, {
  depth: 3,
  url: "#웹에서-가져오기",
  title: _jsx(_Fragment, {
    children: "웹에서 가져오기"
  })
}, {
  depth: 3,
  url: "#node_modules에서-가져오기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "node_modules"
    }), "에서 가져오기"]
  })
}, {
  depth: 2,
  url: "#환경-변수-린팅",
  title: _jsx(_Fragment, {
    children: "환경 변수 린팅"
  })
}, {
  depth: 2,
  url: "#turborepo-lsp",
  title: _jsx(_Fragment, {
    children: "Turborepo LSP"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "로 최상의 경험을 얻으려면 Turborepo는 에디터와 통합하기 위한 몇 가지 유틸리티를 제공합니다."]
    }), "\n", _jsxs(_components.h2, {
      id: "turbojson을-위한-json-schema",
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "을 위한 JSON Schema"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 ", _jsx(_components.a, {
        href: "https://json-schema.org/",
        children: "JSON Schema"
      }), "를 사용하여 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 파일에서 자동 완성을 제공합니다. ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 ", _jsx(_components.code, {
        children: "$schema"
      }), " 키를 포함하면 에디터가 잘못된 형식이나 누락된 키가 있는 경우 전체 문서 및 린팅을 제공할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "웹에서-가져오기",
      children: "웹에서 가져오기"
    }), "\n", _jsxs(_components.p, {
      children: ["아래 표시된 URL에서 ", _jsx(_components.code, {
        children: "schema.json"
      }), "에 액세스할 수 있습니다. 이는 에디터 내 검증을 보기 위해 패키지 매니저의 설치 명령을 실행할 필요가 없다는 장점이 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "https://turborepo.com/schema.<version>.json"
      }), " 형식을 따르는 메이저 버전 ", _jsx(_components.code, {
        children: "schema.json"
      }), "도 사용할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.v1.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "node_modules에서-가져오기",
      children: [_jsx(_components.code, {
        children: "node_modules"
      }), "에서 가져오기"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 2.4부터 패키지 매니저의 설치 명령을 실행하면 ", _jsx(_components.code, {
        children: "node_modules"
      }), "에서 ", _jsx(_components.code, {
        children: "schema.json"
      }), "을 사용할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./node_modules/turbo/schema.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      title: "node_modules 위치",
      children: _jsxs(_components.p, {
        children: ["리포지토리의 루트에 ", _jsx(_components.code, {
          children: "turbo"
        }), "를 설치하는 것을 권장하므로, 스키마 경로는\n리포지토리 루트의 ", _jsx(_components.code, {
          children: "node_modules"
        }), "를 가리켜야 합니다. ", _jsx(_components.a, {
          href: "/docs/reference/package-configurations",
          children: "패키지\n구성"
        }), "에서는\n", _jsx(_components.code, {
          children: "../../node_modules/turbo/schema.json"
        }), "과 같은 경로를 사용해야 할 수 있습니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "환경-변수-린팅",
      children: "환경 변수 린팅"
    }), "\n", _jsx(_components.p, {
      children: "환경 변수를 처리하는 것은 Turborepo에서 애플리케이션을 구축하는 중요한 부분입니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: [_jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " 패키지"]
      }), "는 ESLint 설정을 확장하여 모든 환경 변수를 처리했는지 확인하는 데 도움을 줍니다."]
    }), "\n", _jsx(_components.h2, {
      id: "turborepo-lsp",
      children: "Turborepo LSP"
    }), "\n", _jsx(_components.p, {
      children: "JSON Schema에서 제공하는 것보다 더 많은 자동 완성 및 린팅을 활성화하고, 잘못된 글로브, 존재하지 않는 태스크나 패키지에 대한 참조를 위한 에디터 내 힌트 및 추가 리포지토리 가시성 도구를 제공합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["설치하려면 ", _jsx(_components.a, {
        href: "https://marketplace.visualstudio.com/items?itemName=Vercel.turbo-vsc",
        children: "VSCode Extension Marketplace"
      }), "를 방문하세요."]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "Visual Studio Code를 사용하지 않으시나요?",
      children: _jsxs(_components.p, {
        children: ["언어 서버는 ", _jsx(_components.a, {
          href: "https://microsoft.github.io/language-server-protocol/",
          children: "Language Server\nProtocol"
        }), "을 지원하는\n모든 에디터에서 사용할 수 있습니다. 관심을 표명하려면 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/issues",
          children: "이슈\n트래커"
        }), "에 요청을 기록하세요."]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
